export { default } from './head.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/first.js
// module id = 615
// module chunks = 41